// This file was automatically generated from profile.meds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.passport.profile.meds');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.meds.permList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var tList865 = opt_data.threads;
  var tListLen865 = tList865.length;
  for (var tIndex865 = 0; tIndex865 < tListLen865; tIndex865++) {
    var tData865 = tList865[tIndex865];
    el8.template.passport.profile.meds.threadItem(tData865, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.meds.threadItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isActive) ? '<li class="el8ItemText el8ItemWithDateYrMM"><div class="el8DateYrMM">' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(opt_data.startDate)) : '') + '</div>' + soy.$$escapeHtml(opt_data.latestOrder.displayedMedicationName) + ' ' + soy.$$escapeHtml(opt_data.latestOrder.directions ? opt_data.latestOrder.directions : '') + '</li>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.meds.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ItemText el8ItemWithDateYrMMDD"><div class="el8DateYrMMDD">', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : ''), '</div>', soy.$$escapeHtml(opt_data.displayedMedicationName), ' ');
  el8.template.ptdata.model.medOrder.typeSummary(opt_data, output);
  output.append(' ');
  if (opt_data.quantity || opt_data.quantityUnits) {
    el8.template.ptdata.model.medOrder.displayQuantity(opt_data, output);
    output.append(' ');
  }
  output.append((opt_data.authRefills != '') ? soy.$$escapeHtml(opt_data.authRefills) + ' ' : '', soy.$$escapeHtml(opt_data.directions ? opt_data.directions : ''), '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.meds.dcMedOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ItemText el8ItemWithDateYrMMDD"><div class="el8DateYrMMDD">', (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : ''), '</div>');
  el8.template.ptdata.model.dcMedOrder.orderSummary(opt_data, output);
  output.append('</li>');
  if (!opt_sb) return output.toString();
};
